<script setup lang="ts">
defineProps<{
  results: any;
}>();
</script>

<template>
  <small
    class="font-bold text-yellow-600"
    id="microchip-help"
  >
    <i class="pi pi-exclamation-triangle text-xs" />

    {{
      $t('components.forms.errors.duplicatedMicrochip', { animal: results.length }, results.length)
    }}
  </small>

  <div class="mt-2 flex w-full flex-wrap items-center gap-2">
    <RouterLink
      v-for="{ animal_name, id, _id, path } of results"
      v-tooltip.top="$t('tooltip.microchip.goToAnimal')"
      class="flex h-14 w-12 flex-col items-center justify-center"
      :key="id"
      :to="`/shelter/animal-profile/${_id.$oid}`"
    >
      <AAvatar
        class="w-10 border border-brand-300"
        :src="path || '/paw.png'"
      />

      <p class="af-link w-12 overflow-hidden text-ellipsis whitespace-nowrap text-center text-xs">
        {{ animal_name }}
      </p>
    </RouterLink>
  </div>
</template>
